<template lang="pug">
  .modal.modal--md
    button.modal__close(
    @click="$emit('close')"
    )
      img(src="@/assets/images/icons/icon-close.svg")
    h2.modal__title Отклонить заявку #55736
    .modal__body
      .modal__item
        .modal__item-title 1. Укажите причину отказа
        .modal__item-block
          label.radio
            input(
            type="radio"
            value="1"
            v-model="rejectionType"
            @change="resetError"
            )
            .radio__text Недействительные документы
          label.radio
            input(
            type="radio"
            value="2"
            v-model="rejectionType"
            @change="resetError"
            )
            .radio__text Не прошла по рейтингу
          label.radio
            input(
            type="radio"
            value="3"
            v-model="rejectionType"
            @change="resetError"
            )
            .radio__text Другая причина
      .modal__item
        .modal__item-title 2. Укажите, какие документы являются недействительными
        .modal__item-block
          .form-elem(
            :class="{'form-elem_error' : errors.invalidDoc}"
          )
            textarea.textarea(
            v-model="invalidDoc"
            :disabled="rejectionType === '2' || rejectionType === '3'"
            @input="resetError"
            )
      .modal__item
        .modal__item-title 3. Укажите причину отказа
        .modal__item-block
          .form-elem(
          :class="{'form-elem_error' : errors.otherReason}"
          )
            textarea.textarea(
            v-model="otherReason"
            :disabled="rejectionType === '1' || rejectionType === '2'"
            @input="resetError"
            )
    .modal__button.modal__button--align-right
      button.button.button_paint-error.button_long(
      @click.prevent="onButtonClick"
      )
        .button__text Отправить
      .form-elem__error(
        v-if="currentErrorMessage.length > 0"
      ) {{ currentErrorMessage }}

</template>

<script>
import { mapActions } from "vuex";
import { OrderStatusEnums } from "../../../const";

export default {
  name: "operator-rejection",
  props: ["modalData"],
  data() {
    return {
      rejectionType: "1",
      invalidDoc: "",
      otherReason: "",
      errors: {
        invalidDoc: false,
        otherReason: false,
      },
      currentErrorMessage: "",
    };
  },
  methods: {
    ...mapActions(["updateOrderStatus", "updateOrderStatusBulk", "getOrders"]),
    resetError() {
      this.errors.invalidDoc = false;
      this.errors.otherReason = false;
      this.currentErrorMessage = "";
    },
    onButtonClick() {
      let documents_comment = "";
      let comment = "";
      if (this.rejectionType === "1") {
        if (this.invalidDoc.length === 0) {
          this.currentErrorMessage =
            "Укажите, какие документы являются недействительными";
          this.errors.invalidDoc = true;
          return;
        }
        documents_comment = this.invalidDoc;
      } else if (this.rejectionType === "3") {
        if (this.otherReason.length === 0) {
          this.currentErrorMessage = "Укажите причину отказа";
          this.errors.otherReason = true;
          return;
        }
        comment = this.otherReason;
      }
      if (this.modalData.bulkRejection) {
        this.updateOrderStatusBulk({
          status: OrderStatusEnums.REJECTED,
          ids: this.modalData.orders,
          reject_reason: Number(this.rejectionType),
          documents_comment: documents_comment,
          comment: comment,
        }).then((res) => {
          if (res.status === 200) {
            this.$emit("changeModalMode", "notification", {
              title: "Успешно",
              text: "Заявки были отклонены",
            });
            this.getOrders(this.modalData.paramsForGetOrders);
          } else {
            this.$emit("changeModalMode", "notification", {
              title: "Ошибка",
              text: "Попробуйте повторить позже",
            });
          }
        });
      } else {
        this.updateOrderStatus({
          id: this.modalData.id,
          status: OrderStatusEnums.REJECTED, //id статуса "Отклонена"
          reject_reason: Number(this.rejectionType),
          documents_comment: documents_comment,
          comment: comment,
        }).then((res) => {
          if (res.status === 200) {
            this.$emit("changeModalMode", "notification", {
              title: "Успешно",
              text: "Заявка была отклонена",
              redirectToRequests: true,
            });
          } else {
            this.$emit("changeModalMode", "notification", {
              title: "Ошибка",
              text: "Попробуйте повторить позже",
            });
          }
        });
      }
    },
  },
};
</script>
